import React, { FC } from 'react'
import { Icon, Empty, Col, Row } from 'antd'
import { GlobalSearchHeaders, SearchResult } from '../../types'
import ResultHeader from './ResultHeader'
import Result from './Result'
import styles from './index.module.less'

interface ResultsProps {
	results: SearchResult[]
	resultClicked(): void
	loading: boolean
	headers: GlobalSearchHeaders[]
}

const Results: FC<ResultsProps> = ({ results, loading, resultClicked, headers }) => {
	if (loading)
		return (
			<div className={styles.results}>
				<Icon type='loading' />
			</div>
		)

	if (!results.length)
		return (
			<div className={styles.results}>
				<Empty description='No results found' />
			</div>
		)

	const gutter = 24

	const ResultsColumn: React.FC<{ title: string }> = ({ children, title }) => (
		<Col xs={gutter} xl={gutter / headers.length}>
			<ResultHeader title={title} />
			{children}
		</Col>
	)

	return (
		<div className={styles.results}>
			<Row gutter={gutter}>
				{headers.includes('subscribers') && (
					<ResultsColumn title='Subscribers'>
						{results
							.filter(result => result.entity_type === 'consumer')
							.map(({ organisation_id, username, license_type }) => (
								<Result
									key={username}
									name={username}
									path={`/endcustomer/${organisation_id}/licenses?type=${license_type}&username=${username}`}
									resultClicked={resultClicked}
								/>
							))}
					</ResultsColumn>
				)}
				{headers.includes('end_customers') && (
					<ResultsColumn title='End Customers'>
						{results
							.filter(result => result.entity_type === 'end_customer')
							.map(({ id, name }) => (
								<Result key={id} name={name} path={`/endcustomer/${id}/licenses`} resultClicked={resultClicked} />
							))}
					</ResultsColumn>
				)}
				{headers.includes('resellers') && (
					<ResultsColumn title='Resellers'>
						{results
							.filter(result => result.entity_type === 'reseller')
							.map(({ id, name }) => (
								<Result key={id} name={name} path={`/reseller/${id}/children`} resultClicked={resultClicked} />
							))}
					</ResultsColumn>
				)}
				{headers.includes('service_providers') && (
					<ResultsColumn title='Service Providers'>
						{results
							.filter(result => result.entity_type === 'service_provider')
							.map(({ id, name }) => (
								<Result key={id} name={name} path={`/serviceprovider/${id}/children`} resultClicked={resultClicked} />
							))}
					</ResultsColumn>
				)}
			</Row>
		</div>
	)
}

export default Results
